import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { forgotPassword, login, logout } from '../slices/authSlice';
import { FORGOT_PASSWORD, LOGIN, LOGOUT, RESET_PASSWORD } from "config/apiPaths";
import { SSO_URL } from "config/constants";
import apiRegistry from "utils/apiRegistry";

export const ssoApi = createApi({
  reducerPath: 'ssoApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${SSO_URL}user`,
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: LOGIN,
        method: 'POST',
        data: credentials,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(login({
            token: data?.token, 
            user: data?.userInfo
          }));
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: LOGOUT,
        method: 'GET',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          apiRegistry.forEach(api => dispatch(api.util.resetApiState()))
          dispatch(logout(arg));
        } catch (error) {
          console.error('Logout failed:', error);
        }
      },
    })
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation
} = ssoApi;